import classNames from 'classnames/bind';
import { ReactElement } from 'react';
import { SortOption } from '../../../services/services.constants';
import styles from './SortSelect.module.scss';

const cx = classNames.bind(styles);

export const SORT_OPTION_LABELS: Record<string, string> = {
  [SortOption.relevance]: 'Relevancy',
  [SortOption.publishDate_desc]: 'Latest',
};

interface SortSelectProps {
  options: SortOption[];
  onOptionSelect: (value: SortOption) => void;
  selectedOption: SortOption;
}

const SortSelect = ({ options, onOptionSelect, selectedOption }: SortSelectProps): ReactElement => {
  return (
    <div data-testid="sort-select" className={cx('body')}>
      {options.map((option) => (
        <span
          data-testid={`sort-by-${option}`}
          key={option}
          className={cx('option', { active: selectedOption === option })}
          onClick={() => onOptionSelect(option)}
        >
          {SORT_OPTION_LABELS[option]}
        </span>
      ))}
    </div>
  );
};

export default SortSelect;
